<mat-card>
    <mat-card-header fxLayoutAlign="center">                
        <mat-card-subtitle><h2>Mes demandes de virements</h2></mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>

        <div fxLayout="row wrap" fxLayoutAlign="space-between center" class="w-100 p-2" id="afficheAddcars">
            <div fxFlex="100" fxFlex.gt-sm="33" fxFlex.sm="33">
                
                <button  mat-icon-button  color="primary" matTooltip="Affichage en Grille" (click)="changeViewType('grid')">
                    <span><mat-icon>grid_view</mat-icon></span>
                </button>
                <button  mat-icon-button  color="primary" matTooltip="Affichage en Liste" (click)="changeViewType('list')">
                    <span><mat-icon>format_list_bulleted</mat-icon></span>
                </button>
               
            </div>
        </div>

        <div class="table-wrapper" *ngIf="viewType==='list'">
            <table mat-table [dataSource]="dataSource" matSort class="w-100">
    
                <!-- Amount Column -->
                <ng-container matColumnDef="amount">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Montant </th>
                    <td mat-cell *matCellDef="let transfer">{{transfer.transfer_amount | currency : appService.getCurrency() : 'symbol' :
                        '1.2-2'}}</td>
                </ng-container>

                 <!-- Status Column -->
                 <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> status </th>
                    <td mat-cell *matCellDef="let transfer">
                        <span *ngIf="transfer.transfer_status == 'EN_ATTENTE'" style="color: blue;">En attente de validation</span>
                        <span *ngIf="transfer.transfer_status == 'VALIDER'" style="color: rgb(3, 154, 3);">Valider</span>
                        <span *ngIf="transfer.transfer_status == 'REJETER'" style="color:red;">Rejeter</span>
                        <span *ngIf="transfer.transfer_status == 'EFFECTUER'" style="color: rgb(149, 157, 42);">Effectuer</span>
                    </td>
                </ng-container>

                <!-- Date Column -->
                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                    <td mat-cell *matCellDef="let transfer">{{transfer.created_at | date:"dd MMMM, yyyy 'à' HH:mm" }}</td>
                </ng-container>
                
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let mespaiements; columns: displayedColumns;"></tr>
            </table>
            <p *ngIf="dataSource && dataSource.data.length === 0" class="py-5 mb-0 text-center">Pas de données disponibles</p>
        </div>

        <div fxLayout="row wrap" fxLayoutAlign="center" class="w-100 p-2" *ngIf="viewType==='grid'">
            <mat-card class="menu-item" [fxLayout]="(viewType == 'grid') ? 'column' : 'row'"
                [ngClass]="[viewType + '-item', 'column-'+column]" fxFlex.gt-sm="30" fxFlex.sm="30"  *ngFor="let item of transfers | paginate: { itemsPerPage: 10, currentPage: p }">
               
                <div fxFlex="100" class="p-3">
                    <div fxLayout="column" fxLayoutAlign="start stretch" class="h-100">
                        <mat-card-content class="mb-0">
                            <mat-icon class="icon-title">swap_horiz</mat-icon>
                            <h1 class="title">
                                {{item.transfer_amount | currency : appService.getCurrency() : 'symbol' : '1.2-2'}}
                            </h1>
                            <div> 
                                <div class="features">
                                    <!-- <span>Véhicule : {{item.vehicle}}</span><br> -->
                                    <span *ngIf="item.transfer_status == 'EN_ATTENTE'" style="color: blue; font-size:24px"><mat-icon class="">clock_arrow_up</mat-icon> En attente de validation</span>
                                    <span *ngIf="item.transfer_status == 'VALIDER'" style="color: rgb(3, 154, 3); font-size:24px" ><mat-icon class="">task_alt</mat-icon> Valider</span>
                                    <span *ngIf="item.transfer_status == 'REJETER'" style="color:red; font-size:24px"><mat-icon class="">unpublished</mat-icon> Rejeter</span>
                                    <span *ngIf="item.transfer_status == 'EFFECTUER'" style="color: rgb(149, 157, 42); font-size:24px"><mat-icon class="">done_all</mat-icon> Effectuer</span>
                                </div>
                            </div>
                        </mat-card-content>
                        <mat-card-actions class="m-0 p-0">
                            <div class="divider mt-1">
                                <span class="text-muted text-center">
                                    {{item.created_at| date:"dd MMMM, yyyy 'a' HH:mm" }}
                                </span>
                            </div>
                        </mat-card-actions>
                    </div>
                </div>
            </mat-card>
            <p *ngIf="transfers && transfers.length === 0" class="py-5 mb-0 text-center">Pas de données disponibles</p> 

        </div>
        <div fxLayout="row wrap" fxLayoutAlign="space-between" class="w-100 p-2">
            <div fxFlex="100" fxFlex.gt-sm="20" fxFlex.sm="20">
                <button  mat-icon-button  color="primary" matTooltip="Rafraichir" (click)="refresh()">
                    <span><mat-icon>refresh</mat-icon> Mise à jour</span>
                </button>
            </div>
            
            <div fxFlex="100" fxFlex.gt-sm="80" fxFlex.sm="80" *ngIf="viewType==='grid'">
                <pagination-controls (pageChange)="p = $event" style="text-align: end;"></pagination-controls>
            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 25, 50]" class="{{viewType==='list' ? 'block' : 'hidden'}}" ></mat-paginator>
        </div>
    </mat-card-content>
</mat-card>